<div class="bottom__bar bg-[#233f71] flex justify-between items-center justify-items-center h-11 p-2 ">
    <div class="bottom__left h-full flex  items-center justify-start text-center">
       <a href="" routerLink="/contact" class="mx-1"><img appVersion src="./assets/img/icon/email.avif" alt="" class="brightness-0 invert  h-7 cursor-pointer"></a>
      <a href="tel:0888393511" class="ml-2"><img appVersion src="./assets/img/icon/call.avif" alt="" class="brightness-0 invert w-7 h-7 cursor-pointer"></a>
    </div>
    <img appVersion src="./assets/img/logo/logo-bottom-bar.webp" alt="" class="h-full">
</div>

